import React from 'react';
import type { ILeaguePlayerCard } from '../types/players';
import { formatRoleLabel, getPlayerInitials } from '../constants';

interface PlayerRosterCardProps {
  player: ILeaguePlayerCard;
  onClick?: (player: ILeaguePlayerCard) => void;
}

const PlayerRosterCard: React.FC<PlayerRosterCardProps> = ({ player, onClick }) => {
  const fullName = [player.playerFirstName, player.playerLastName].filter(Boolean).join(' ') || '—';
  const roleLabel = formatRoleLabel(player.playerRole);

  return (
    <div
      className="player-roster-card"
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick ? () => onClick(player) : undefined}
    >
      <div className="player-roster-card__top">
        <div className="player-roster-card__avatar" aria-hidden>
          {getPlayerInitials(player.playerFirstName, player.playerLastName)}
        </div>

        <div className="player-roster-card__identity">
          <div className="player-roster-card__name">{fullName}</div>
          {player.playerCode && (
            <div className="player-roster-card__player-id">Player ID: {player.playerCode}</div>
          )}
          <div className="player-roster-card__team">{player.teamName ?? '—'}</div>
        </div>

        {roleLabel && <div className="player-roster-card__role-badge">{roleLabel}</div>}
      </div>

      <div className="player-roster-card__stats">
        <div className="player-roster-card__stat">
          <div className="player-roster-card__stat-value">{player.totalMatches}</div>
          <div className="player-roster-card__stat-label">Matches</div>
        </div>
        <div className="player-roster-card__stat player-roster-card__stat--divided">
          <div className="player-roster-card__stat-value">{player.totalRuns}</div>
          <div className="player-roster-card__stat-label">Runs</div>
        </div>
        <div className="player-roster-card__stat">
          <div className="player-roster-card__stat-value">{player.totalWickets}</div>
          <div className="player-roster-card__stat-label">Wickets</div>
        </div>
      </div>
    </div>
  );
};

export default PlayerRosterCard;
